import { CheckCircleIcon } from "@heroicons/react/24/solid";
import React from "react";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function AlertError(message: string) {
  toast(message, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    transition: Zoom,
    progress: undefined,
    type: "error",
    theme: "light",
  });
}

export function AlertWarning(message: string, key?: number) {
  toast(message, {
    position: "top-right",
    autoClose: 1500,
    toastId: key,
    hideProgressBar: true,
    transition: Zoom,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    type: "warning",
    theme: "light",
  });
}

export function AlertSuccess(message: string, key?: number) {
  toast(message, {
    position: "top-right",
    autoClose: 1500,
    toastId: key,
    hideProgressBar: true,
    transition: Zoom,
    icon: <CheckCircleIcon className="text-primary w-7 h-7" />,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    type: "success",
    theme: "light",
  });
}

export function AlertInfo(message: string) {
  toast.info(message);
}
